import React, { useEffect, useRef, useState } from 'react';
import { Tooltip, Typography } from '@mui/material';
import { agentDescriptionStyle } from './utils';

const AgentDescriptionWithTooltip: React.FC<{ text: string }> = ({ text }) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (textRef.current) {
      const { scrollHeight } = textRef.current;
      setIsTruncated(scrollHeight > 80);
    }
  }, [text]);

  return (
    <Tooltip title={isTruncated ? text : ''}>
      <Typography ref={textRef} variant="body2" sx={agentDescriptionStyle}>
        {text}
      </Typography>
    </Tooltip>
  );
};

export default AgentDescriptionWithTooltip;
